export const PhoneIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: 'scaleX(-1)' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9003 0.532654L11.0868 0.0126229C10.5315 -0.0694322 9.99655 0.255476 9.81336 0.786003L8.47994 4.92625C8.30692 5.42363 8.49707 5.97479 8.93997 6.25967L11.1001 7.68642C10.7467 9.23985 10.5534 10.8333 7.76657 12.7467L5.85978 11.08C5.49403 10.7121 4.93015 10.6281 4.47303 10.8733L0.606131 12.9467C0.11377 13.2103 -0.117089 13.7903 0.059431 14.3202L1.27284 17.927C1.45645 18.4269 1.9568 18.7376 2.48624 18.6804C11.8201 17.8204 16.7804 10.7999 15.9004 1.53938C15.8396 1.01308 15.4262 0.596922 14.9003 0.532654ZM2.39957 17.5404L1.19283 13.9735L5.0264 11.92L7.54655 14.2135C10.9334 12.2134 11.7268 10.2132 12.5135 7.20639L9.60668 5.27961L10.9401 1.19269L14.7137 1.69939C15.5204 10.2866 11.1001 16.7203 2.39957 17.5404Z"
      fill="currentColor"
    />
  </svg>
);
